import React, { useEffect, useState } from 'react';

import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';

import { Container, Content, GroupSelection, ProductSelection, SaveButtonSpace } from './styles';

import stylesMaterial from './stylesMaterial';
import GroupsService, { Group, Product } from '../../../services/GroupsService';
import { useAuth } from '../../../hooks/auth';
import { Checkbox, FormControlLabel, FormGroup, IconButton } from '@material-ui/core';
import { Option } from './Option';

interface SelectProductsModalProps {
  open: boolean;
  handleClose: () => void;
  selectedGroups: Group[];
  selectedProducts: Product[];
  setSelectedGroups: (value: Group[]) => void;
  setSelectedProducts: (value: Product[]) => void;
}

export function SelectProductsModal(props: SelectProductsModalProps) {
  const {
    open,
    handleClose,
    selectedGroups,
    selectedProducts,
    setSelectedGroups,
    setSelectedProducts
  } = props;
  const classes = stylesMaterial();
  const { user } = useAuth();

  const [groups, setGroups] = useState<Group[]>([]);
  const [tempSelectedGroups, setTempSelectedGroups] = useState<Group[]>([]);
  const [tempSelectedProducts, setTempSelectedProducts] = useState<Product[]>([]);

  useEffect(() => {
    GroupsService.listGroups(user.empresa_id, true).then((res) => {
      setGroups(res);
      setTempSelectedGroups(res.filter((group) => selectedGroups.map((sGroup) => sGroup.id).includes(group.id)));
    }).catch((error) => console.log(error));
    
    setTempSelectedProducts(selectedProducts);
  }, []);

  function handleSelectGroup(id: number) {
    if(tempSelectedGroups.map((group) => group.id).includes(id)) {
      setTempSelectedGroups(tempSelectedGroups.filter((group) => group.id !== id));

      const group = groups.find((group) => group.id === id);

      if(group) {
        const productsIds = group.products?.map((product) => product.id);

        if(productsIds) {
          setTempSelectedProducts(tempSelectedProducts.filter((product) => !productsIds.includes(product.id)));
        }
      }
    } else {
      const group = groups.find((group) => group.id === id);

      if(group) {
        setTempSelectedGroups(tempSelectedGroups.concat(group));

        if(group) {
          if(group.products) {
            setTempSelectedProducts(tempSelectedProducts.concat(group.products));
          }
        }
      }
    }
  }

  function handleSelectProduct(id: number) {
    if(tempSelectedProducts.map((product) => product.id).includes(id)) {
      setTempSelectedProducts(tempSelectedProducts.filter((product) => product.id !== id));
    } else {
      const tempProducts = groups.map((group) => group.products);
      const products = tempProducts.reduce((prev, next) => prev?.concat(next || []));

      if(products) {
        const product = products.find((product) => product.id === id);
        
        if(product) {
          setTempSelectedProducts(tempSelectedProducts.concat(product));
        }
      }
    }
  }

  function selectAll() {
    const tempProducts = groups.map((group) => group.products);
    const products = tempProducts.reduce((prev, next) => prev?.concat(next || []));

    if(products) {
      setTempSelectedGroups(groups);
      setTempSelectedProducts(products);
    }
  }

  function clear() {
    setTempSelectedGroups([]);
    setTempSelectedProducts([]);
  }

  function handleSaveSelections() {
    setSelectedGroups(tempSelectedGroups);
    setSelectedProducts(tempSelectedProducts);

    handleClose();
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      id="select-products-modal"
      className={classes.modal}
    >
      <Container>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className={classes.buttonClose}
        >
          <CloseIcon className={classes.iconClose} />
        </IconButton>

        <Content>
          <GroupSelection>
            <h1>Seleção de grupos</h1>
            <FormGroup id="groups" row>
              <FormControlLabel
                control={
                  <Checkbox 
                    checked={groups.length === tempSelectedGroups.length} 
                    name='checkAll'
                    onClick={groups.length === tempSelectedGroups.length ? clear : selectAll}
                  />
                }
                label={groups.length === tempSelectedGroups.length ? 'Desmarcar todos' : 'Marcar todos'}
              />
              {groups.map((group) => (
                <Option
                  key={group.id}
                  name={group.name}
                  id={group.id}
                  handleSelection={handleSelectGroup}
                  selected={tempSelectedGroups.map((group) => group.id)}
                />
              ))}
            </FormGroup>
          </GroupSelection>

          <ProductSelection>
            <h1>Seleção de produtos</h1>
            
            {tempSelectedGroups.map((group) => (
              <div key={group.id}>
                <h2>{group.name}</h2>

                <FormGroup id={`products-${group.id}`} row>
                  {group.products?.map((product) => (
                    <Option
                      key={product.id}
                      name={product.name}
                      id={product.id}
                      handleSelection={handleSelectProduct}
                      selected={tempSelectedProducts.map((product) => product.id)}
                    />
                  ))}
                </FormGroup>
              </div>
            )
            )}
          </ProductSelection>
        </Content>

        <SaveButtonSpace>
          <button onClick={handleSaveSelections}>
            Salvar
          </button>
        </SaveButtonSpace>
      </Container>
    </Modal>
  );
}